import { app } from "./app";
import { getFirestore, serverTimestamp, doc, getDoc } from "firebase/firestore";
import type {
  Firestore,
  DocumentSnapshot,
  DocumentData,
} from "firebase/firestore";

export const db: Firestore = getFirestore(app);
export const now = serverTimestamp;

export async function getUserDoc(
  uid: string
): Promise<DocumentSnapshot<DocumentData>> {
  return getDoc(doc(db, "users", uid));
}
